module.exports = __webpack_public_path__ + "h5/img/b3.a5cf628e.jpeg";